"use client";

import { useMemo } from "react";
import {
  NextIntlClientProvider,
  useLocale,
  useMessages,
  useTimeZone,
} from "next-intl";
import { mergeMessages } from "@/i18n/client-messages";

type Messages = Record<string, unknown>;

/**
 * 부모 Provider 메시지 + 이 라우트 범위 추가분을 깊은 병합해 내려준다.
 * 서버(ScopedIntlProvider)는 추가분만 직렬화한다 — 전역 문구를 RSC 페이로드에 다시
 * 싣지 않기 위해서. locale·timeZone 은 부모 Provider 값을 그대로 잇는다(SSR·하이드레이션
 * 모두 같은 부모를 보므로 결과가 같다).
 */
export function ScopedMessagesProvider({
  messages,
  children,
}: {
  messages: Messages;
  children: React.ReactNode;
}) {
  const locale = useLocale();
  const timeZone = useTimeZone();
  const parent = useMessages() as Messages;
  const merged = useMemo(() => mergeMessages(parent, messages), [parent, messages]);
  return (
    <NextIntlClientProvider locale={locale} timeZone={timeZone} messages={merged}>
      {children}
    </NextIntlClientProvider>
  );
}
